<template>
  <banner
    :icon="!hideIcon ? 'fa-exclamation-circle' : ''"
    :title="title"
    class="information"
  >
    <slot></slot>
  </banner>
</template>
<script>
import Banner from "./Banner.vue";

export default {
  components: { Banner },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "sass:color";
@import "@/_css/variables";

.information {
  border-color: $storm;
  color: $storm;
  background-color: color.adjust($storm, $lightness: 50%);
}
</style>
